import { Component, inject, input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TopUpDirective } from '@core/services/prepayment/top-up.directive';
import { ButtonAtomComponent } from '@shared/atoms/button-atom/button-atom.component';
import { ButtonSquareAtomComponent } from '@shared/atoms/button-square-atom/button-square-atom.component';
import { formatMarketplacePrice } from '@shared/utils/currency/format-marketplace-price.util';

export type FreeAmountButtonPosition = 'first' | 'last' | 'hidden';

@Component({
  selector: 'app-prepayment-top-up',
  templateUrl: './prepayment-top-up.component.html',
  styleUrls: ['./prepayment-top-up.component.scss'],
  standalone: true,
  hostDirectives: [
    {
      directive: TopUpDirective,
      outputs: ['topUpEvents'],
    },
  ],
  imports: [CommonModule, TranslateModule, ButtonAtomComponent, ButtonSquareAtomComponent],
  providers: [CurrencyPipe],
})
export class PrepaymentTopUpComponent implements AfterViewInit {
  @ViewChild('priceInput') priceInput!: ElementRef<HTMLInputElement>;

  public readonly freeAmountButtonPosition = input<FreeAmountButtonPosition>('first');

  protected readonly topUpDirective = inject(TopUpDirective);
  private readonly currencyPipe = inject(CurrencyPipe);

  ngAfterViewInit(): void {
    // Focus on input after view initialization
    setTimeout(() => {
      this.priceInput?.nativeElement?.focus();
    }, 100);
  }

  protected formatPrice(amountInCents: number): string {
    return formatMarketplacePrice(amountInCents, this.topUpDirective.marketplaceCurrency(), {
      amountInCents: true,
      currencyPipe: this.currencyPipe,
    });
  }

  // Generate placeholder text for input with dynamic currency
  protected getInputPlaceholder(): string {
    const exampleAmount = 2500; // 25.00 as example
    const formattedAmount = this.formatPrice(exampleAmount);
    return formattedAmount;
  }
}
